/**
 * Generates a SHA256 hash of the provided string using the Web Crypto API.
 * This is used to create an anonymous, stable user identifier for Amplitude.
 * The original value cannot be recovered from the hash.
 *
 * @param {string} value - The value to hash (e.g., eligMemberId)
 * @returns {Promise<string>} A hex-encoded SHA256 hash string
 * @throws {Error} If hashing fails (e.g., crypto.subtle is unavailable)
 */
export async function sha256(value) {
	const encoder = new TextEncoder();
	const data = encoder.encode(value);
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
